import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const reSendActivationApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    reSendActivation: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/activation/resend',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
